import React, { useEffect, useState } from 'react';
import { useCookies, withCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';

const ForgotComponent = ({ api }) => {
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState(null)

  const handleForgot = async (e) => {
    e.preventDefault();

    if (!loading) {
      setLoading(true)
      try {
        const resp = await api().requestForgotPasswordLink({
          email: email
        })

        if (resp.status === 200) {
          setMessage(resp.data.message)
        }

      } catch (error) {
        setError("Something went wrong...")
      }
      setLoading(false)
    }
  };

  return (
    <div className="bg-gradient-to-b from-blue-400 to-green-700 min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-sm w-full">
        <h2 className="text-2xl font-semibold mb-2 text-center">Forgot your password?</h2>
        <h3 className="mb-2">Enter your email, and we'll send you a link to reset your password.</h3>
        {error && <p className="text-red-500 text-center mb-4">{error}</p>}
        <form onSubmit={handleForgot}>
          <div className="mb-4">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
            <input
              type="email"
              id="email"
              className="w-full p-2 mt-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <button
            disabled={loading}
            type="submit"
            className={
              loading
                ? "w-full p-2 bg-gray-200 text-white rounded-md  focus:outline-none"
                : "w-full p-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none"
            }
          >
            Send reset link
          </button>
          {message && (
            <p className="mt-2 text-green-600 text-sm semi-bold">{message}</p>
          )}
        </form>
      </div>
    </div>
  );
};

const Forgot = withCookies(({ api }) => (
  <div>
    <Header api={api} />
    <ForgotComponent api={api} />
  </div>
))

export default Forgot;